import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import CloseRound from "../../icon-components/close-round";
import Search from "../../icon-components/search";

var ListHeaderSearch = function ListHeaderSearch(_ref) {
  var onCountrySearch = _ref.onCountrySearch,
      onCountrySearchCancel = _ref.onCountrySearchCancel,
      searchQuery = _ref.searchQuery,
      formatMessage = _ref.formatMessage,
      messages = _ref.messages;

  var handleTerritorySearch = function handleTerritorySearch(event) {
    var value = event.target.value;
    if (value.length === 0) return onCountrySearchCancel();
    return onCountrySearch(value);
  };

  var handleClearSearch = function handleClearSearch() {
    onCountrySearchCancel();
  };

  var closeIconClasses = cx({
    'ListHeaderSearch-close': true,
    hide: searchQuery.length === 0
  });
  return React.createElement("div", {
    className: "ListHeaderSearch"
  }, React.createElement("span", {
    className: "ListHeaderSearch-search"
  }, React.createElement(Search, null)), React.createElement("input", {
    type: "text",
    className: "ListHeaderSearch-field",
    placeholder: formatMessage(messages.searchPlaceholder),
    onChange: handleTerritorySearch,
    value: searchQuery
  }), React.createElement("span", {
    className: closeIconClasses,
    onClick: handleClearSearch
  }, React.createElement(CloseRound, null)));
};

ListHeaderSearch.propTypes = {
  onCountrySearch: PropTypes.func,
  onCountrySearchCancel: PropTypes.func,
  searchQuery: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired
};
export default ListHeaderSearch;